<div class="card inner-shadow">
  <div class="card-body">
    <div class="header">
      <p class="title text-left">{{ task?.name }}</p>
      <div class="action-btn">
        <button class="btn btn-sm btn-circle btn-outline-primary">
          <i class="icon-files"></i>
        </button>
        <button class="btn btn-sm btn-circle btn-outline-primary">
          <i class="icon-pencil"></i>
        </button>
      </div>
    </div>
    <table>
      <tr>
        <th>Asset</th>
        <td>{{task?.location?.name}}</td>
      </tr>
      <tr>
        <th>Annotation</th>
        <td>{{task?.annotation?.name}}</td>
      </tr>
      <tr>
        <th>Due Date</th>
        <td>{{task?.fixing_date | date}}</td>
      </tr>
      <tr>
        <th>Status</th>
        <td>Ongoing</td>
      </tr>
    </table>
    <p class="description">Description</p>
    <p class="description-body">{{task?.description}}</p>
    <div style="padding-top: 10px; display: flex;">
      <div style="flex: 1;"></div>
      <button type="submit" class="btn btn-sm btn-primary"
        (click)="onUpdate()">{{ 'Update Status' | translate }}</button>
    </div>
  </div>
</div>